import { BaseBus } from "./BaseBus";

export class DivisionBus extends BaseBus {

    constructor(busObj: DivisionBus = null) {
        super(busObj);
    }

    divisionName: string;
    regionId: string;
    divisionId: string;

    CID(): any {
        return this.divisionId;
    }
}